import { resolveByCountry } from '@codex/helpers';

export function convertImageUrlFromBrainToSmallerImage(imageUrl) {
  const matches = imageUrl.match(/^(.*)\/((u_|l_).*\.*)$/);
  const imageUrlPrefix = matches[1];
  const imageName = matches[2].replace('u_', 'g_').replace('l_', 'g_');

  return `${imageUrlPrefix}/${imageName}`;
}

export function normalizePriceInfoForProduct(productDataFromStoreAPI) {
  const currencySign = resolveByCountry('£', '€');

  return {
    currentPriceNumber: Number((productDataFromStoreAPI.price.amount / 100).toFixed(2)),
    currentPrice: `${currencySign}${(productDataFromStoreAPI.price.amount / 100).toFixed(2)}`,
    // price.discountAmount = -1 coming from Store API sometimes which means that product has no discount
    // that's why subcondition productDataFromStoreAPI.price.discountAmount !== -1 is here
    ...(productDataFromStoreAPI.price.discountAmount && productDataFromStoreAPI.price.discountAmount !== -1 &&
      { savingsPrice:
          `${currencySign}${(Math.abs(productDataFromStoreAPI.price.discountAmount) / 100).toFixed(2)}` }),
    ...(productDataFromStoreAPI.wasPrice && productDataFromStoreAPI.wasPrice.discountAmount &&
      {
        savingsPrice:
          `${currencySign}${(Math.abs(productDataFromStoreAPI.wasPrice.discountAmount) / 100).toFixed(2)}`,
        wasPrice:
          `${currencySign}${(productDataFromStoreAPI.wasPrice.amount / 100).toFixed(2)}`,
        wasPriceFrom: productDataFromStoreAPI.wasPrice.dateFrom.split('-').reverse().join('/'),
        wasPriceTo: productDataFromStoreAPI.wasPrice.dateTo.split('-').reverse().join('/')
      }
    )
  };
}

// Generates URL prefix of the listing page e. g. https://www.currys.co.uk/gbuk/acer-computing/laptops/laptops
// for laptops with ACER brand filter option selected
//
// The prefix of segment listing page can contain universe, category, market, segment, brand filters and type filters
// That's why this function is a quite complex
export function getPageUrlPrefixForSegmentListingPage(
  pageUrlStart, selectedSingleBrandFilterLabel, selectedSingleTypeFilterLabel, ucmsCategorization) {
  const { universeName, categoryName, marketName, segmentName } = ucmsCategorization;

  let universeOrFiltersPartOfUrl;

  if (selectedSingleBrandFilterLabel && selectedSingleTypeFilterLabel) {
    universeOrFiltersPartOfUrl =
      normalizeNameToURL(`${selectedSingleBrandFilterLabel} ${selectedSingleTypeFilterLabel}`);
  } else if (selectedSingleTypeFilterLabel) {
    universeOrFiltersPartOfUrl = normalizeNameToURL(selectedSingleTypeFilterLabel);
  } else if (selectedSingleBrandFilterLabel) {
    universeOrFiltersPartOfUrl = normalizeNameToURL(`${selectedSingleBrandFilterLabel} ${universeName}`);
  } else {
    universeOrFiltersPartOfUrl = normalizeNameToURL(universeName);
  }

  const categoryPartOfUrl = normalizeNameToURL(categoryName);

  const marketAndSegmentPartOfUrl = (marketName.trim().toLowerCase() === segmentName.trim().toLowerCase())
    ? normalizeNameToURL(marketName)
    : `${normalizeNameToURL(marketName)}/${normalizeNameToURL(segmentName)}`;

  // remove special character from URL
  const urlPrefixForSegmentListingPage =
    `${pageUrlStart}/${universeOrFiltersPartOfUrl}/${categoryPartOfUrl}/${marketAndSegmentPartOfUrl}`
      .replace(/\\|,|;|<|>|\{|\}|\(|\)|\*|\[|\]/g, '');

  return urlPrefixForSegmentListingPage;
}

export function getSingleSelectedBrandFilter(filtersFromSearchLabs) {
  const selectedValuesOfBrandFilters =
    filtersFromSearchLabs.find((filter) => filter.id === 'brand_id')
      ? filtersFromSearchLabs.find((filter) => filter.id === 'brand_id')
        .values
        .filter((value) => value.selected)
      : undefined;

  if (selectedValuesOfBrandFilters && selectedValuesOfBrandFilters.length === 1) {
    return selectedValuesOfBrandFilters[0];
  }

  return null;
}

export function getSingleSelectedTypeFilter(filtersFromSearchLabs) {
  const selectedValuesOfTypeFilters =
    filtersFromSearchLabs.find((filter) => filter.label === 'Type')
      ? filtersFromSearchLabs.find((filter) => filter.label === 'Type')
        .values
        .filter((value) => value.selected)
      : undefined;

  if (selectedValuesOfTypeFilters && selectedValuesOfTypeFilters.length === 1) {
    const typeFilterId = filtersFromSearchLabs.find((filter) => filter.label === 'Type').id;

    return { ...selectedValuesOfTypeFilters[0], filterId: typeFilterId };
  }

  return null;
}

function normalizeNameToURL(name) {
  return name.trim()
    .replace(/\s&\s/, ' ') // replace standalone ampersand by white space e. g. Health & wellbeing -> Health wellbeing
    .replace(/\s+/g, ' ') // replace more whitespaces with only one whitespace
    .split(' ')
    .join('-')
    .toLowerCase();
}
